export default __webpack_public_path__ + "static/media/gallery5.3da42eaa.jpeg";